import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';
import { es } from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from 'react-i18next';
import IconMC from './IconMC';

registerLocale('es', es);

const dateInTimeZone = (date, timeZone) => (
  date && timeZone
    ? new Date(date.toLocaleString('en-US', { timeZone }))
    : date
);

const DatePickerMC = ({
  label,
  dateFormat,
  timeInputLabel,
  minDate,
  maxDate,
  name,
  helperChildren,
  timeZone,
  showTimeInput = false,
  showMonthDropdown = false,
  showYearDropdown = false,
  className = '',
  onChange,
  portalId,
  popperClassName = '',
  popperPlacement,
  inputClassName = ''
}) => {
  const { control, formState: { errors }, trigger } = useFormContext();
  const { t } = useTranslation();

  const selectedMinDate = dateInTimeZone(minDate, timeZone);
  const selectedMaxDate = dateInTimeZone(maxDate, timeZone);

  const handleChange = (date, fieldChange) => {
    fieldChange(date);
    if (errors[name]) {
      trigger(name);
    }

    if (onChange) {
      onChange(date);
    }
  };

  const inputClasses = [
    'tw-wrapper',
    'tw-bg-gray-50',
    'tw-rounded-xl',
    'tw-px-4',
    'tw-py-0.5 ',
    'tw-relative',
    'tw-border',
    'tw-appearance-none',
    'focus:tw-outline-none',
    'focus:tw-ring-2',
    'focus:tw-ring-blue-400',
    className
  ].join(' ');

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={dateInTimeZone(new Date(), timeZone)}
      render={({ field }) => (
        <div className={inputClasses}>
          <div className="tw-flex tw-items-center tw-justify-between">
            <div>
              {label && (
              <label
                htmlFor={label}
                className="tw-text-xs tw-text-blue-500 tw-mb-0 tw-block"
              >
                {label}
              </label>
              )}
              <DatePicker
                selected={field.value}
                onChange={(date) => handleChange(date, field.onChange)}
                timeInputLabel={timeInputLabel}
                dateFormat={dateFormat}
                showTimeInput={showTimeInput}
                minDate={selectedMinDate}
                maxDate={selectedMaxDate}
                showMonthDropdown={showMonthDropdown}
                showYearDropdown={showYearDropdown}
                portalId={portalId}
                popperPlacement={popperPlacement}
                locale="es"
                popperClassName={`${popperClassName} tw-z-50 tw-absolute`.trim()}
                className={`tw-text-default/[22px] tw-text-gray-800 tw-p-0 tw-bg-transparent tw-w-full ${inputClassName}`.trim()}
                placeholderText={t('customer.view_list.modal_filters.select_date')}
              />
            </div>
            <IconMC
              name="calendar-outline"
              size="base"
              className="tw-text-gray-600"
            />
          </div>
          {errors[name] && <p className="tw-text-xs tw-text-red-500">{errors[name].message}</p>}
          {helperChildren && helperChildren()}
        </div>
      )}
    />
  );
};

export default DatePickerMC;
